import { DEFAULT_TIMEZONE } from "@consts";

import { BLACKLISTED_EMAIL_PROVIDER_DOMAINS, DEFAULT_ACCOUNT_TYPE, DIALOG_HELPER_TEXTS } from "./AccountEditorConsts";

export const createField = (value = "", errorText = "") => ({ value, errorText });

export const createDefaultAccountFields = () => ({
  accountId: createField(""),
  name: createField(""),
  salesforceAccountId: createField(""),
  timezone: createField(DEFAULT_TIMEZONE),
  accountType: createField(DEFAULT_ACCOUNT_TYPE),
  sftpUrl: createField(""),
  proactiveSftpUrl: createField(""),
  sftpIpList: createField([]),
  publicKey: createField(""),
  supportedDomains: createField([]),
  extraSupportedEmails: createField([])
});

export const wrapAccountRow = (rowData, type) => ({
  ...rowData,
  name: createField(rowData.name),
  accountId: createField(rowData.accountId),
  salesforceAccountId: createField(rowData.salesforceAccountId || ""),
  timezone: createField(rowData.timezone || DEFAULT_TIMEZONE),
  accountType: createField(rowData.accountType || DEFAULT_ACCOUNT_TYPE),
  supportedDomains: createField(rowData.supportedDomains || []),
  extraSupportedEmails: createField(rowData.extraSupportedEmails || []),
  ...(type === "edit" && {
    sftpIpList: createField([]),
    publicKey: createField("")
  })
});

export const unwrapFieldValues = (data) => {
  const result = {};
  for (const [key, val] of Object.entries(data)) {
    result[key] = val && typeof val === "object" && "value" in val ? val.value : val;
  }
  return result;
};

export const validateAccountName = (value) => {
  const regexp = /^(?! )+[a-zA-Z0-9 ]*(?<! )$/i;
  const matches = value.match(regexp);
  return value.length && matches ? "" : DIALOG_HELPER_TEXTS.accountName;
};

export const validateAccountId = (value) => {
  const regexp = /^(?! )+[a-z0-9]+(?:-[a-z0-9]+)*(?<! )$/i;
  const matches = value.match(regexp);
  return value.length && matches ? "" : DIALOG_HELPER_TEXTS.accountId;
};

export const validateSalesforceAccountId = (value) => {
  if (!value) return "";
  const regexp = /^[a-zA-Z0-9]{15,18}$/;
  return regexp.test(value) ? "" : DIALOG_HELPER_TEXTS.salesforceAccountId;
};

export const validateIpAddress = (value) => {
  const regex = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})(\/(\d{1,2}))?$/;
  const match = value.match(regex);
  if (!match) return false;

  const octets = [match[1], match[2], match[3], match[4]].map(Number);
  if (octets.some((o) => o > 255)) return false;

  if (match[6] !== undefined) {
    const prefix = Number(match[6]);
    if (prefix > 32) return false;
  }

  return true;
};

export const validateEmailAddress = (value) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(value);
};

export const isBlacklistedDomain = (value) =>
  BLACKLISTED_EMAIL_PROVIDER_DOMAINS.some((domain) => domain.toLowerCase() === value.toLowerCase());
